/* eslint-disable no-console */
/**
 * Logger Utility
 * Replaces direct console calls to ensure no logs in production.
 * Enable logs in Prod/Dev by setting process.env.REACT_APP_DEBUG = 'true'
 * or window.__DEBUG__ = true
 */

const isDev = typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production';

const isDebugEnabled = () => {
    if (typeof window !== 'undefined' && window.__DEBUG__) return true;
    if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_DEBUG === 'true') return true;
    return isDev; // Back to normal
};

export const logger = {
    log: (...args) => isDebugEnabled() && console.log(...args),
    warn: (...args) => isDebugEnabled() && console.warn(...args),
    error: (...args) => isDebugEnabled() && console.error(...args),
    info: (...args) => isDebugEnabled() && console.info(...args),
    debug: (...args) => isDebugEnabled() && console.debug(...args),
    table: (...args) => isDebugEnabled() && console.table(...args),
    group: (...args) => isDebugEnabled() && console.group(...args),
    groupEnd: (...args) => isDebugEnabled() && console.groupEnd(...args),
    count: (...args) => isDebugEnabled() && console.count(...args),
};

export default logger;
